import React, { useState, useCallback, useContext } from "react";
import { ehCanalRestrito } from "../../helpers/canalConexao";
import { toast } from "react-toastify";
import { format, parseISO } from "date-fns";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import {
	Button,
	TableBody,
	TableRow,
	TableCell,
	//IconButton,
	Table,
	TableHead,
	Paper,
	Tooltip,
	Typography,
	CircularProgress,
} from "@material-ui/core";
import {
	//Edit,
	//CheckCircle,
	SignalCellularConnectedNoInternet2Bar,
	SignalCellularConnectedNoInternet0Bar,
	SignalCellularOff,
	SignalCellular4Bar,
	CropFree,
	//DeleteOutline,
} from "@material-ui/icons";

import MainContainer from "../../components/MainContainer";
//import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import TableRowSkeleton from "../../components/TableRowSkeleton";

import api, { createApi } from "../../services/api";
import WhatsAppModal from "../../components/WhatsAppModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import QrcodeModal from "../../components/QrcodeModal";
import { i18n } from "../../translate/i18n";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import toastError from "../../errors/toastError";
import { urlRetornoErp, temUrlErp } from "../../helpers/urlRetornoCrm";

const CLEAN_REASONS = [
	"logged_out",
	"multidevice_mismatch",
	"qr_expired",
	"connection_replaced",
	"user_disconnect",
	"duplicate_number",
];

const isCleanSession = (whatsApp) =>
	CLEAN_REASONS.indexOf(whatsApp?.lastDisconnectReason) !== -1;

const isForbidden = (whatsApp) =>
	whatsApp?.lastDisconnectReason === "forbidden";

const isDuplicateNumber = (whatsApp) =>
	whatsApp?.lastDisconnectReason === "duplicate_number";

const useStyles = makeStyles(theme => ({
	mainPaper: {
		flex: 1,
		padding: theme.spacing(1),
		overflowY: "scroll",
		...theme.scrollbarStyles,
	},
	customTableCell: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	tooltip: {
		backgroundColor: "#f5f5f9",
		color: "rgba(0, 0, 0, 0.87)",
		fontSize: theme.typography.pxToRem(14),
		border: "1px solid #dadde9",
		maxWidth: 450,
	},
	tooltipPopper: {
		textAlign: "center",
	},
	buttonProgress: {
		color: green[500],
	},
	icon: {
		color: theme.palette.primary.main
	},
	botaoVoltarCRM: {
		position: "fixed",
		width: "50px",
		height: "50px",
		bottom: "50px",
		left: "40px",
		backgroundColor: "#4CAF50",
		color: "#FFF",
		borderRadius: "50px",
		textAlign: "center",
		fontSize: "20px",
		boxShadow: "1px 1px 2px #888",
		zIndex: 1000,
	},
}));

const CustomToolTip = ({ title, content, children }) => {
	const classes = useStyles();

	return (
		<Tooltip
			arrow
			classes={{
				tooltip: classes.tooltip,
				popper: classes.tooltipPopper,
			}}
			title={
				<React.Fragment>
					<Typography gutterBottom color="inherit">
						{title}
					</Typography>
					{content && <Typography>{content}</Typography>}
				</React.Fragment>
			}
		>
			{children}
		</Tooltip>
	);
};

const TicketsWhatsappList = ({whatsAppsIds}) => {
	const classes = useStyles();

	const { whatsApps, loading } = useContext(WhatsAppsContext);
	const [whatsAppModalOpen, setWhatsAppModalOpen] = useState(false);
	const [qrModalOpen, setQrModalOpen] = useState(false);
	const [selectedWhatsApp, setSelectedWhatsApp] = useState(null);
	const [confirmModalOpen, setConfirmModalOpen] = useState(false);

	let filialId = parseInt(localStorage.getItem("filialId"));
	let whatsAppsFilial = [];

	whatsApps.forEach(element => {
		if (whatsAppsIds.includes(element.id)) {
			whatsAppsFilial.push(element);
		}
	});

	const confirmationModalInitialState = {
		action: "",
		title: "",
		message: "",
		whatsAppId: "",
		open: false,
	};
	const [confirmModalInfo, setConfirmModalInfo] = useState(
		confirmationModalInitialState
	);

	const apiForWhatsApp = (whatsApp) => {
		if (!whatsApp?.urlBackend) return api;
		const instance = createApi(whatsApp.urlBackend);
		const token = localStorage.getItem("token");
		if (token) {
			instance.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
		}
		return instance;
	};

	const handleStartWhatsAppSession = async whatsApp => {
		try {
			await apiForWhatsApp(whatsApp).post(`/whatsappsession/${whatsApp.id}`);
		} catch (err) {
			toastError(err);
		}
	};

	const handleGenerateQrCode = async whatsApp => {
		try {
			await apiForWhatsApp(whatsApp).put(`/whatsappsession/${whatsApp.id}`);
		} catch (err) {
			toastError(err);
		}
	};

	/*const handleOpenWhatsAppModal = () => {
		setSelectedWhatsApp(null);
		setWhatsAppModalOpen(true);
	};*/

	const handleCloseWhatsAppModal = useCallback(() => {
		setWhatsAppModalOpen(false);
		setSelectedWhatsApp(null);
	}, [setSelectedWhatsApp, setWhatsAppModalOpen]);

	const handleOpenQrModal = whatsApp => {
		setSelectedWhatsApp(whatsApp);
		setQrModalOpen(true);
	};

	const handleCloseQrModal = useCallback(() => {
		setSelectedWhatsApp(null);
		setQrModalOpen(false);
	}, [setQrModalOpen, setSelectedWhatsApp]);

	/*const handleEditWhatsApp = whatsApp => {
		setSelectedWhatsApp(whatsApp);
		setWhatsAppModalOpen(true);
	};*/

	const handleOpenConfirmationModal = (action, whatsApp) => {
		if (action === "disconnect") {
			setConfirmModalInfo({
				action: action,
				title: i18n.t("connections.confirmationModal.disconnectTitle"),
				message: i18n.t("connections.confirmationModal.disconnectMessage"),
				whatsAppId: whatsApp.id,
				urlBackend: whatsApp.urlBackend,
			});
			setConfirmModalOpen(true);
		}
	};

	const handleSubmitConfirmationModal = async () => {
		if (confirmModalInfo.action === "disconnect") {
			try {
				await apiForWhatsApp({ urlBackend: confirmModalInfo.urlBackend })
					.delete(`/whatsappsession/${confirmModalInfo.whatsAppId}`);
			} catch (err) {
				toastError(err);
			}
		}

		if (confirmModalInfo.action === "delete") {
			try {
				await api.delete(`/whatsapp/${confirmModalInfo.whatsAppId}`);
				toast.success(i18n.t("connections.toasts.deleted"));
			} catch (err) {
				toastError(err);
			}
		}

		setConfirmModalInfo(confirmationModalInitialState);
	};

	const renderActionButtons = whatsApp => {
		return (
			<>
				{whatsApp.status === "qrcode" && (
					<Button
						size="small"
						variant="contained"
						color="primary"
						onClick={() => handleOpenQrModal(whatsApp)}
					>
						{i18n.t("connections.buttons.qrcode")}
					</Button>
				)}
				{whatsApp.status === "DISCONNECTED" && isCleanSession(whatsApp) && (
					<Button
						size="small"
						variant="outlined"
						color="primary"
						onClick={() => handleGenerateQrCode(whatsApp)}
					>
						{i18n.t("connections.buttons.generateQr")}
					</Button>
				)}
				{whatsApp.status === "DISCONNECTED" && isForbidden(whatsApp) && (
					<>
						<Button
							size="small"
							variant="outlined"
							color="primary"
							onClick={() => handleStartWhatsAppSession(whatsApp)}
						>
							{i18n.t("connections.buttons.tryAgain")}
						</Button>{" "}
						<Button
							size="small"
							variant="outlined"
							color="secondary"
							onClick={() => handleGenerateQrCode(whatsApp)}
						>
							{i18n.t("connections.buttons.newDevice")}
						</Button>
					</>
				)}
				{whatsApp.status === "DISCONNECTED" && !isCleanSession(whatsApp) && !isForbidden(whatsApp) && (
					<Button
						size="small"
						variant="outlined"
						color="primary"
						onClick={() => handleStartWhatsAppSession(whatsApp)}
					>
						{i18n.t("connections.buttons.tryAgain")}
					</Button>
				)}
				{(whatsApp.status === "CONNECTED" ||
					whatsApp.status === "PAIRING" ||
					whatsApp.status === "TIMEOUT") && (
						<span title={ehCanalRestrito(whatsApp) ? i18n.t("connections.buttons.disconnectOficialHint") : undefined}>
							<Button
								size="small"
								variant="outlined"
								color="secondary"
								disabled={ehCanalRestrito(whatsApp)}
								onClick={() => {
									if (ehCanalRestrito(whatsApp)) return;
									handleOpenConfirmationModal("disconnect", whatsApp);
								}}
							>
								{i18n.t("connections.buttons.disconnect")}
							</Button>
						</span>
					)}
				{whatsApp.status === "OPENING" && (
					<Button size="small" variant="outlined" disabled color="default">
						{i18n.t("connections.buttons.connecting")}
					</Button>
				)}
			</>
		);
	};

	const renderStatusToolTips = whatsApp => {
		return (
			<div className={classes.customTableCell}>
				{whatsApp.status === "DISCONNECTED" && isDuplicateNumber(whatsApp) && (
					<CustomToolTip
						title={i18n.t("connections.toolTips.duplicateNumber.title")}
						content={i18n.t("connections.toolTips.duplicateNumber.content")}
					>
						<SignalCellularConnectedNoInternet0Bar color="secondary" />
					</CustomToolTip>
				)}
				{whatsApp.status === "DISCONNECTED" && isCleanSession(whatsApp) && !isDuplicateNumber(whatsApp) && (
					<CustomToolTip
						title={i18n.t("connections.toolTips.cleanSession.title")}
						content={i18n.t("connections.toolTips.cleanSession.content")}
					>
						<SignalCellularOff style={{ color: "#9e9e9e" }} />
					</CustomToolTip>
				)}
				{whatsApp.status === "DISCONNECTED" && isForbidden(whatsApp) && (
					<CustomToolTip
						title={i18n.t("connections.toolTips.forbidden.title")}
						content={i18n.t("connections.toolTips.forbidden.content")}
					>
						<SignalCellularConnectedNoInternet0Bar color="secondary" />
					</CustomToolTip>
				)}
				{whatsApp.status === "DISCONNECTED" && !isCleanSession(whatsApp) && !isForbidden(whatsApp) && (
					<CustomToolTip
						title={i18n.t("connections.toolTips.disconnected.title")}
						content={i18n.t("connections.toolTips.disconnected.content")}
					>
						<SignalCellularConnectedNoInternet0Bar color="secondary" />
					</CustomToolTip>
				)}
				{whatsApp.status === "OPENING" && (
					<CircularProgress size={24} className={classes.buttonProgress} />
				)}
				{whatsApp.status === "qrcode" && (
					<CustomToolTip
						title={i18n.t("connections.toolTips.qrcode.title")}
						content={i18n.t("connections.toolTips.qrcode.content")}
					>
						<CropFree />
					</CustomToolTip>
				)}
				{whatsApp.status === "CONNECTED" && (
					<CustomToolTip title={i18n.t("connections.toolTips.connected.title")}>
						<SignalCellular4Bar style={{ color: green[500] }} />
					</CustomToolTip>
				)}
				{(whatsApp.status === "TIMEOUT" || whatsApp.status === "PAIRING") && (
					<CustomToolTip
						title={i18n.t("connections.toolTips.timeout.title")}
						content={i18n.t("connections.toolTips.timeout.content")}
					>
						<SignalCellularConnectedNoInternet2Bar color="secondary" />
					</CustomToolTip>
				)}
			</div>
		);
	};

	return (
		<MainContainer>
			<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css"></link>
			{temUrlErp() && (
				<a href={urlRetornoErp()}
					className={classes.botaoVoltarCRM} target="_self" title="Retornar ao ERP">
					<i style={{ marginTop: "16px" }} className="fa fa-mail-reply"></i>
				</a>
			)}

			<ConfirmationModal
				title={confirmModalInfo.title}
				open={confirmModalOpen}
				onClose={setConfirmModalOpen}
				onConfirm={handleSubmitConfirmationModal}
			>
				{confirmModalInfo.message}
			</ConfirmationModal>
			<QrcodeModal
				open={qrModalOpen}
				onClose={handleCloseQrModal}
				whatsAppId={!whatsAppModalOpen && selectedWhatsApp?.id}
			/>
			<WhatsAppModal
				open={whatsAppModalOpen}
				onClose={handleCloseWhatsAppModal}
				whatsAppId={!qrModalOpen && selectedWhatsApp?.id}
			/>
			{/* Sem MainHeader/Title aqui: a aba já se chama "Conexões" (o título
				"Conexões WhatsApp" continua na tela própria, pages/Connections). */}
			<Paper className={classes.mainPaper} variant="outlined">
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell align="center">
								ID
							</TableCell>
							<TableCell align="center">
								{i18n.t("connections.table.name")}
							</TableCell>
							<TableCell align="center">
								{i18n.t("connections.table.connectedNumber")}
							</TableCell>
							<TableCell align="center">
								{i18n.t("connections.table.status")}
							</TableCell>
							<TableCell align="center">
								{i18n.t("connections.table.session")}
							</TableCell>
							<TableCell align="center">
								{i18n.t("connections.table.lastUpdate")}
							</TableCell>
							{/* <TableCell align="center">
								{i18n.t("connections.table.default")}
							</TableCell>
							<TableCell align="center">
								{i18n.t("connections.table.actions")}
							</TableCell> */}
						</TableRow>
					</TableHead>
					<TableBody>
						{loading ? (
							<TableRowSkeleton />
						) : (
							<>
								{whatsAppsFilial?.length > 0 &&
									whatsAppsFilial.map(whatsApp => (
										<TableRow key={whatsApp.id}>
											<TableCell align="center">{whatsApp.id}</TableCell>
											<TableCell align="center">{whatsApp.name}</TableCell>
											<TableCell align="center">
												{whatsApp.status === "CONNECTED"
													? whatsApp.connectedNumber || "—"
													: "—"}
											</TableCell>
											<TableCell align="center">
												{renderStatusToolTips(whatsApp)}
											</TableCell>
											<TableCell align="center">
												{renderActionButtons(whatsApp)}
											</TableCell>
											<TableCell align="center">
												{format(parseISO(whatsApp.updatedAt), "dd/MM/yy HH:mm")}
											</TableCell>
											{/* <TableCell align="center">
												{whatsApp.isDefault && (
													<div className={classes.customTableCell}>
														<CheckCircle style={{ color: green[500] }} />
													</div>
												)}
											</TableCell>
											<TableCell align="center">
												<IconButton className={classes.icon}
													size="small"
													onClick={() => handleEditWhatsApp(whatsApp)}
												>
													<Edit />
												</IconButton>

												<IconButton className={classes.icon}
													size="small"
													onClick={e => {
														handleOpenConfirmationModal("delete", whatsApp.id);
													}}
												>
													<DeleteOutline />
												</IconButton>
											</TableCell> */}
										</TableRow>
									))}
							</>
						)}
					</TableBody>
				</Table>
			</Paper>
		</MainContainer>
	);
};

export default TicketsWhatsappList;
